import { LazyLoad } from 'app/utils';

export const ProductFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.ProductFormPage,
);
